// src/styles/theme.ts
export const theme = {
  colors: {
    primary: '#757a75ff',
    primaryDark: '#8c978cff',
    secondary: '#2196F3',
    secondaryDark: '#1976D2',
    accent: '#FF9800',
    background: '#f5f5f5',
    cardBackground: '#ffffff',
    text: '#1b1b1bff',
    textLight: '#666666',
    border: '#e0e0e0',
    success: '#4CAF50',
    error: '#a7a5a58e',
    warning: '#FF9800',
    info: '#2196F3'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    full: '9999px'
  },
  shadows: {
    sm: '0 2px 4px rgba(0,0,0,0.1)',
    md: '0 4px 8px rgba(0,0,0,0.15)',
    lg: '0 8px 16px rgba(0,0,0,0.2)',
    xl: '0 16px 32px rgba(0,0,0,0.25)'
  },
  transitions: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease'
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    large: '1440px'
  }
};

export type Theme = typeof theme;